import script from "./MigrateDeviceProtocolsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./MigrateDeviceProtocolsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./MigrateDeviceProtocolsDialog.vue?vue&type=style&index=0&id=6fefe622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fefe622"]])

export default __exports__